import Backbone from "../../libs/backbone/backbone";
import GenericModel from "./generic.model.ts";

export default GenericModel.extend(
{
    urlRoot : 'rest/api/organizations',
    id : null,
    title : "",
    description : "",
    tellodyApiKey: ""

});

